var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75065 4.91665V1.66665C5.75065 1.37933 5.86479 1.10378 6.06795 0.900614C6.27112 0.69745 6.54667 0.583313 6.83398 0.583313H15.5007C15.788 0.583313 16.0635 0.69745 16.2667 0.900614C16.4698 1.10378 16.584 1.37933 16.584 1.66665V4.91665H20.9173C21.2046 4.91665 21.4802 5.03078 21.6834 5.23395C21.8865 5.43711 22.0007 5.71266 22.0007 5.99998V21.1666C22.0007 21.454 21.8865 21.7295 21.6834 21.9327C21.4802 22.1358 21.2046 22.25 20.9173 22.25H1.41732C1.13 22.25 0.85445 22.1358 0.651285 21.9327C0.448121 21.7295 0.333984 21.454 0.333984 21.1666V5.99998C0.333984 5.71266 0.448121 5.43711 0.651285 5.23395C0.85445 5.03078 1.13 4.91665 1.41732 4.91665H5.75065ZM16.584 7.08331V12.5H19.834V7.08331H16.584ZM14.4173 7.08331H7.91732V12.5H14.4173V7.08331ZM5.75065 7.08331H2.50065V12.5H5.75065V7.08331ZM7.91732 2.74998V4.91665H14.4173V2.74998H7.91732Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.bfb947117ff3c668b7d38db8e450a653.svg";
export { ForwardRef as ReactComponent };